import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconMailEdit: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.79199 15.832C9.79199 16.177 9.51199 16.457 9.16699 16.457H4.16699C2.15199 16.457 1.04199 15.347 1.04199 13.332V5.83203C1.04199 3.81703 2.15199 2.70703 4.16699 2.70703H14.167C16.182 2.70703 17.292 3.81703 17.292 5.83203V8.33203C17.292 8.67703 17.012 8.95703 16.667 8.95703C16.322 8.95703 16.042 8.67703 16.042 8.33203V5.83203C16.042 4.51786 15.4812 3.95703 14.167 3.95703H4.16699C2.85283 3.95703 2.29199 4.51786 2.29199 5.83203V13.332C2.29199 14.6462 2.85283 15.207 4.16699 15.207H9.16699C9.51199 15.207 9.79199 15.487 9.79199 15.832ZM14.2553 6.29787C14.0528 6.01954 13.6629 5.9562 13.3821 6.16036L9.28866 9.13703C9.21532 9.18953 9.11785 9.18953 9.04451 9.13703L4.95109 6.16036C4.66942 5.9562 4.28038 6.02037 4.07788 6.29787C3.87455 6.57704 3.93625 6.96869 4.21541 7.17119L8.30863 10.1479C8.5653 10.3345 8.86618 10.4279 9.16618 10.4279C9.46618 10.4279 9.76789 10.3345 10.0237 10.1479L14.1169 7.17119C14.3969 6.96786 14.4595 6.57704 14.2553 6.29787ZM18.9587 12.4004C18.9578 12.7654 18.8154 13.1087 18.557 13.3662L13.9603 17.9412C13.8428 18.0579 13.6844 18.1237 13.5194 18.1237H11.667C11.322 18.1237 11.042 17.8437 11.042 17.4987V15.647C11.042 15.482 11.107 15.3229 11.2245 15.2062L15.8003 10.6087C16.0578 10.3495 16.4011 10.207 16.7661 10.207C16.7661 10.207 16.7671 10.207 16.7679 10.207C17.1329 10.207 17.4754 10.3487 17.7329 10.607L18.5579 11.4329C18.817 11.6912 18.9587 12.0345 18.9587 12.4004ZM16.6853 11.4912L16.1578 12.0212L17.1445 13.0079L17.6745 12.4804C17.7028 12.4529 17.7087 12.4212 17.7087 12.3987C17.7087 12.3762 17.7028 12.3445 17.6745 12.3162L16.8495 11.4904C16.822 11.462 16.7904 11.4562 16.7679 11.4562C16.7454 11.4562 16.7145 11.4629 16.6853 11.4912ZM16.2587 13.8895L15.2762 12.907L12.292 15.9054V16.8745H13.2612L16.2587 13.8895Z"
      fill={color}
    />
  </svg>
);

export default IconMailEdit;
